import styled from 'styled-components';

export const Container = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.6rem;
	padding: 0.8rem;
	background: var(--ticto-background);
	border-bottom: 1px solid var(--ticto-outline);

	p {
		margin: 0;
	}
`;

export const MethodList = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.4rem;
	padding: 1rem;
	background: var(--ticto-shape);
	border-radius: 0.4rem;
`;

export const MethodItem = styled.button<{ $selected: boolean }>`
	display: grid !important;
	grid-template-columns: 1fr auto 30px !important;
	align-items: center !important;
	gap: 0.5rem !important;
	height: 2.75rem !important;
	padding: 0 0.75rem !important;
	cursor: pointer !important;
	text-align: left !important;
	border-radius: 0.4rem !important;
	border: 1px solid ${({ $selected }) => ($selected ? 'var(--ticto-green)' : 'var(--ticto-outline)')} !important;
	background: var(--ticto-background) !important;
	color: var(--ticto-text) !important;
	transition: filter 0.2s !important;

	&:hover {
		filter: brightness(0.95) !important;
	}
`;

export const UsedBefore = styled.span`
	font-size: 0.7rem;
	font-weight: 600;
	color: var(--ticto-green) !important;
`;

export const Checkbox = styled.span<{ $checked: boolean }>`
	width: 23px;
	height: 23px;
	border-radius: 0.2rem;
	background-color: var(--ticto-green-light);
	display: inline-flex;
	align-items: center;
	justify-content: center;
	font-size: 1.1rem;
	color: var(--ticto-green);

	&::before {
		content: '${({ $checked }) => ($checked ? '✔' : '')}';
	}
`;
